import 'debug';
import { d as pageMixin } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

//
var script = {
  mixins: [pageMixin],
  data: function data() {
    return {
      nfcCode: null,
      selectedLangCode: null,
      selectedBranchIds: [],
      branches: [],
      nfcCodeFound: false
    };
  },
  mounted: function mounted() {
    this.$xp.navigation.preventAutoHide();
    this.$xp.navigation.showNav();
    window.localStorage.setItem('nfcPageId', this.pageData.ID);
    this.selectedLangCode = window.localStorage.getItem('nfcLangCode');
    this.selectedBranchIds = window.localStorage.getItem('nfcSelectedBranchIds') || [];

    if (this.$route.query.nfcCode) {
      this.nfcCode = this.$route.query.nfcCode;

      if (typeof this.nfcCode === 'string' && parseInt(this.nfcCode) > 0 && parseInt(this.nfcCode).toString() === this.nfcCode) {
        this.nfcCode = parseInt(this.nfcCode);
      }

      this.buildBranches();
    }
  },
  methods: {
    setAppLang: function setAppLang(lang) {
      window.localStorage.setItem('nfcLangCode', lang.langCode);
      this.$xp.polyglot.setLanguage(lang.langCode, lang.path);
      this.selectedLangCode = lang.langCode;
      this.$router.push('/' + lang.path + 'page/' + this.pageData.ID + '?nfcCode=' + this.$route.query.nfcCode);
    },
    goToPage: function goToPage(item) {
      console.log('goToPage', item);
      var selectedBranchIds = [];
      var p = item;

      while (p.ancestorId) {
        selectedBranchIds.push(p.ancestorId);
        p = this.nfcData.ancestors[p.ancestorId];
      }

      window.localStorage.setItem('nfcSelectedBranchIds', selectedBranchIds);
      this.$router.push('/page/' + item.id);
    },
    clickBranch: function clickBranch(item) {
      if (item.children.length) {
        this.goToPage(item.children[0]);
      }
    },
    isInSelectedBranch: function isInSelectedBranch(item) {
      return this.selectedBranchIds.includes(item.id) || this.selectedBranchIds.includes(item.ancestorId);
    },
    buildBranches: function buildBranches() {
      var _this = this;

      if (this.nfcData.pages[this.nfcCode]) {
        if (this.nfcData.pages[this.nfcCode].length === 1 && this.nfcData.autoStart) {
          this.goToPage(this.nfcData.pages[this.nfcCode][0]);
        }

        this.nfcData.pages[this.nfcCode].forEach(function (item) {
          _this.nfcCodeFound = true;

          _this.addBranchItem(item);
        });
      }
    },
    addBranchItem: function addBranchItem(item) {
      item = Object.assign({}, item);

      if (!item.children) {
        item.children = [];
      }

      if (item.ancestorId) {
        var found = this.branches.find(function (x) {
          return x.id === item.ancestorId;
        });

        if (found) {
          found.children.push(item);
        } else if (this.nfcData.ancestors[item.ancestorId]) {
          var ancestor = this.nfcData.ancestors[item.ancestorId];
          var added = this.addBranchItem(ancestor);
          added.children.push(item);
        }
      } else {
        this.branches.push(item);
      }

      return item;
    }
  },
  computed: {
    nfcData: function nfcData() {
      return this.pageData.nfc;
    },
    languageMenuItems: function languageMenuItems() {
      var items = [];
      this.pageData.LanguageVirtualFolders.forEach(function (item) {
        items.push({
          id: item.ID,
          langName: item.LangName,
          langCode: item.LangCode,
          langId: item.LangID,
          path: item.Path,
          icon: item.Icon
        });
      });
      return items;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.selectedLangCode == null && _vm.languageMenuItems.length > 1
    ? _c("div", { staticClass: "c-select-language-page" }, [
        _c(
          "ul",
          { staticClass: "c-pages-menu menu" },
          _vm._l(this.languageMenuItems, function(language) {
            return _c(
              "li",
              {
                key: language.id,
                staticClass: "c-select-language-page__menu-item menu__item link"
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "c-select-language-page__link",
                    attrs: { href: "#", role: "link" },
                    on: {
                      click: function($event) {
                        $event.preventDefault();
                        return _vm.setAppLang(language)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "c-select-language-page__name" }, [
                      _vm._v(_vm._s(language.langName))
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "c-select-language-page__icon",
                      attrs: {
                        src: language.icon,
                        alt: language.langName,
                        "aria-hidden": "true"
                      }
                    })
                  ]
                )
              ]
            )
          }),
          0
        )
      ])
    : _vm.nfcCodeFound
    ? _c("div", { staticClass: "c-nfc-page" }, [
        _c(
          "ul",
          { staticClass: "c-pages-menu menu" },
          _vm._l(_vm.branches, function(item) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "c-nfc-page__menu-item menu__item link"
              },
              [
                item.children.length == 0
                  ? _c(
                      "a",
                      {
                        staticClass: "c-nfc-page__link",
                        attrs: { href: "#", role: "link" },
                        on: {
                          click: function($event) {
                            $event.preventDefault();
                            return _vm.goToPage(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "c-nfc-page__name" }, [
                          _vm._v(_vm._s(item.title))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.children.length
                  ? _c(
                      "a",
                      {
                        class:
                          (_vm.isInSelectedBranch(item) ? "selected " : "") +
                          "c-nfc-page__name",
                        attrs: { href: "#", role: "link" },
                        on: {
                          click: function($event) {
                            $event.preventDefault();
                            return _vm.clickBranch(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "c-nfc-page__name" }, [
                          _vm._v(_vm._s(item.title))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.children.length
                  ? _c(
                      "ul",
                      { staticClass: "c-pages-menu menu" },
                      _vm._l(item.children, function(subitem) {
                        return _c(
                          "li",
                          {
                            key: subitem.id,
                            staticClass: "c-nfc-page__menu-item menu__item link"
                          },
                          [
                            subitem.children.length == 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "c-nfc-page__link",
                                    attrs: { href: "#", role: "link" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault();
                                        return _vm.goToPage(subitem)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class:
                                          (_vm.isInSelectedBranch(item)
                                            ? "selected "
                                            : "") + "c-nfc-page__name"
                                      },
                                      [_vm._v(_vm._s(subitem.title))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            subitem.children.length
                              ? _c("div", { staticClass: "c-nfc-page__name" }, [
                                  _vm._v(_vm._s(subitem.title))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            subitem.children.length
                              ? _c("ul", { staticClass: "c-pages-menu menu" }, [
                                  _c("li", [_vm._v("too deep")])
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ])
    : _vm.$route.query.nfcCode
    ? _c(
        "div",
        { staticClass: "c-nfc-page" },
        [
          _c("xp-section", { staticClass: "c-nfc-page__not-found" }, [
            _c("div", { staticClass: "js-entry o-entry c-text-entry" }, [
              _c("div", { staticClass: "c-text-entry__content" }, [
                _vm._v(
                  "\n                Dem NFC code " +
                    _vm._s(_vm.$route.query.nfcCode) +
                    " ist kein Inhalt zugeordnet.\n            "
                )
              ])
            ])
          ])
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "c-nfc-page" },
        _vm._l(_vm.pageData.Sections, function(section) {
          return _c(
            "xp-section",
            { key: section.ID },
            _vm._l(section.entries, function(entry) {
              return _c("dynamic-entry", {
                key: entry.ID,
                attrs: { entryData: entry, id: "entry-" + entry.ID }
              })
            }),
            1
          )
        }),
        1
      )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
